<!-- eslint-disable no-const-assign -->
<template>
  <div>
    <v-container class="px-8 py-0 error-page">
      <v-row class="ma-0 pa-0 inner-padding">
        <v-col cols="12" class="pa-0">
          <div class="img-wrap mx-auto text-center">
            <v-img
              src="data:image/png;base64,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"
            ></v-img>
          </div>
        </v-col>
      </v-row>

      <v-row class="mb-0 pa-0 contents-wrap">
        <v-col cols="12" class="pa-0 text-center page-title">
          서비스 접속이 원활하지 않습니다.<br />
        </v-col>
        <v-col
          cols="12"
          class="mt-3 pa-0 text-center desc"
          v-if="message === '' || message === undefined || message === null"
        >
          Code:
          {{
            status !== '' && status !== undefined && status !== null
              ? status
              : 500
          }}
          <br />
          {{
            message === '' || message === undefined || message === null
              ? '일시적인 오류로 인해 서비스에 접속할 수 없습니다.'
              : ''
          }}<br />
          {{
            message === '' || message === undefined || message === null
              ? '문제를 해결하기 위해 노력하고 있습니다.'
              : ''
          }}<br />
          {{
            message === '' || message === undefined || message === null
              ? '잠시 후 다시 확인해주세요.'
              : ''
          }}
        </v-col>
        <v-col
          cols="12"
          class="mt-3 pa-0 text-center desc"
          v-if="message !== '' && message !== undefined && message !== null"
        >
          Code:
          {{
            status !== '' && status !== undefined && status !== null
              ? status
              : 500
          }}
          <br />
          {{ message }}<br />
        </v-col>
      </v-row>

      <v-row class="ma-0 mt-6 pa-0 justify-center">
        <v-col cols="12" class="ma-0 pa-0 btn-wrap">
          <v-btn
            block
            elevation="0"
            color="darkGrey"
            class="btn-move"
            @click="userLogout()"
          >
            <span class="white--text">
              <v-icon class="mr-1">mdi-login</v-icon>
              iBGF로 이동
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import routerNames from '@/const/routerConstants';
import { callApp } from '@/utils/app/callApp.js';
import { mapGetters } from 'vuex';
import { logout } from '@/api/auth';

export default {
  props: {
    status: Number,
    message: String,
  },

  computed: {
    ...mapGetters(['IS_ANDROID', 'IS_IOS']),
  },

  methods: {
    /* 로그인화면으로 이동 */
    toLogin() {
      // 쿠키제거
      this.$store.commit('cleanToken');
      // 앱 로그아웃 호출
      if (this.IS_ANDROID || this.IS_IOS) {
        callApp.logout();
      }
      // 로그인페이지로 이동
      this.$router.push({
        name: routerNames.Login,
        params: { type: 'authExpired' },
      });
    },

    /* 로그아웃 */
    async userLogout() {
      try {
        const response = await logout();
        // console.log('###########userLogout response###################');
        // console.log(JSON.stringify(response));
        // console.log('#################################################');
        if (response.data.message === 'OK') {
          this.$store.commit('cleanToken');
        } else {
          alert('잠시 후 다시 시도해주세요.');
        }
      } catch (error) {
        console.log(error);
      }
      // IBGF로 이동
      const url = 'exit_webview';
      location.href = url;
    },

    /* 뒤로가기 방지 */
    handlePopstate() {
      history.go(1);
    },
  },

  created() {
    // console.log('[ERROR!] ', this.message);
    window.history.pushState(null, '', location.href);
    window.addEventListener('popstate', this.handlePopstate);
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopstate);
  },
};
</script>
